<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-flex ts-item-end">
        <ts-input
          v-tooltip="$t('productProfile.transferSearch')"
          v-model="search"
          :placeholder="$t('productProfile.transferSearch')"
          style="width: 100%;"
          class="inline-block"
        />
      </div>
      <div class="overflow-auto ts-mt-3">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.transfer_no }}</td>
            <td>{{ record.from_branch_name }}</td>
            <td>{{ record.from_location_name }}</td>
            <td>{{ record.transferred_name }}</td>
            <td>{{ record.to_branch_name }}</td>
            <td>{{ record.to_location_name }}</td>
            <td></td>
            <td>{{ record.received_by_name }}</td>
            <td>{{ record.received_date }}</td>
            <td class="ts-text-center">
              <span
                class="badge badge-success"
                v-if="record.transfer_status_id == 2"
                >{{ record.transfer_status }}</span
              >
              <span
                class="badge badge-warning"
                v-if="record.transfer_status_id == 1"
                >{{ record.transfer_status }}</span
              >
              <span
                class="badge badge-danger"
                v-if="record.transfer_status_id == 1"
                >{{ record.transfer_status }}</span
              >
            </td>
             <td>{{ record.received_comment }}</td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'transferReceived',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('product/productDetailTransferReceived', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.productDetailTransferReceived.search
      },
      set(newValue) {
        this.$store.commit('product/productDetailTransferReceived/SET_SEARCH', newValue)
        this.$store.commit('product/productDetailTransferReceived/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('productProfile.transferNo'), style: 'width: 7%' },
        { name: this.$t('productProfile.fromBranch') },
        { name: this.$t('productProfile.fromWarehouse') },
        { name: this.$t('productProfile.transferBy') },
        { name: this.$t('productProfile.toBranch') },
        { name: this.$t('productProfile.toWarehouse') },
        { name: this.$t('productProfile.remark') },
        { name: this.$t('productProfile.receivedBy') },
        { name: this.$t('productProfile.receivedDate') },
        {
          name: this.$t('productProfile.status'),
          style: 'text-align:center'
        },
        { name: this.$t('productProfile.reason') }
      ]
    }
  },
  methods: {
    ...mapActions('product/productDetailTransferReceived', ['fetch']),
    fetchData() {
      this.loading = true
      this.fetch(this.$route.params.id)
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  }
}
</script>
